import React from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { isBankIdVerified } from "../../../../authentication/state/selectors";

interface StateProps {
    canContinue: boolean;
}

type CustomerContinueButtonProps = StateProps;

const CustomerContinueButton: React.FC<CustomerContinueButtonProps> = ({ canContinue }) => (
    <Button
        id="customer-form-button"
        form={FORM_ID.PERSONAL_DETAILS_FWA}
        variant="primary"
        disabled={!canContinue}
        type="submit"
    >
        Neste
    </Button>
);

const mapStateToProps = (state: RootState): StateProps => ({
    canContinue: isBankIdVerified(state),
});

export default connect(mapStateToProps)(CustomerContinueButton);
